/** @format */
import {Box, Button, Menu, MenuItem} from '@mui/material';
import {styled} from '@mui/material/styles';

interface ButtonHelpProps {
  active: boolean;
}

export const HelpContainer = styled(Box)(() => ({
  marginLeft: '-12px',
}));

export const ButtonHelp = styled(Button, {
  shouldForwardProp: prop => prop !== 'active',
})<ButtonHelpProps>(({theme, active}) => ({
  padding: 0,
  '#contactSupportStop1, #contactSupportStop2': {
    transition: '0.2s',
  },

  '#contactSupportStop1': {
    stopColor: theme.palette.figma_primary?.[active ? 'light' : 'dark'],
  },

  '#contactSupportStop2': {
    stopColor: theme.palette.figma_primary?.[active ? 'light' : 'main'],
  },

  '& svg path': {
    transition: 'fill 0.2s',
    fill: active ? '#83C0F5' : undefined,
  },

  '&:hover': {
    background: 'transparent',

    '#contactSupportStop1': {
      stopColor: theme.palette.figma_primary?.[active ? 'light' : 'main'],
    },

    '#contactSupportStop2': {
      stopColor: theme.palette.figma_primary?.light,
    },

    '& svg path': {
      fill: '#58ACF2',
    },
  },
}));

export const StyledMenu = styled(Menu)(() => ({
  '.MuiList-root': {
    display: 'flex',
    flexDirection: 'column',
    gap: '1px',
  },
}));

export const StyledMenuItem = styled(MenuItem)(({theme}) => ({
  height: '48px',
  gap: theme.spacing(2),
  padding: theme.spacing(0, 4),
  background: theme.palette.figma_primary?.dark,

  '&:hover': {
    background: theme.palette.figma_primary?.main,
  },
}));
